<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="92%" append-to-body>
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <el-button v-if="showSubmit" type="primary" size="small" :disabled="actionBusy" @click="submit">提交审批</el-button>
            <el-button v-if="showWfApprove" type="primary" size="small" :disabled="actionBusy" @click="wfApprove">审批通过</el-button>
            <el-button v-if="showWfReject" type="primary" size="small" :disabled="actionBusy" @click="wfReject">驳回</el-button>
            <el-button v-if="showApprove" type="primary" size="small" :disabled="actionBusy" @click="approveHandle">审核</el-button>
            <el-button v-if="showUnapprove" type="primary" size="small" :disabled="actionBusy" @click="unapproveHandle">弃审</el-button>
            <el-button v-if="showTrail" type="primary" size="small" @click="trailVisible = true">审批轨迹</el-button>
            <el-button v-if="isAuth('purchase:purchaseStockIn:update')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="readonly = false">修改</el-button>
            <el-button v-if="isAuth('purchase:purchaseStockIn:delete')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="deleteHandle">删除</el-button>
          </el-button-group>
          <div v-if="workflowActionHint" class="wf-hint">{{ workflowActionHint }}</div>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="dataForm" :rules="formRules" label-width="100px" :disabled="formReadonly">
      <el-row>
        <el-col :span="6">
          <el-form-item label="入库单号" prop="stockInCode">
            <el-input v-model="dataForm.stockInCode" :readonly="codeReadonly || !!dataForm.stockInId" :placeholder="codeReadonly && !dataForm.stockInId ? '保存时自动生成' : ''" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="入库日期" prop="stockInDate">
            <el-date-picker v-model="dataForm.stockInDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="供应商"><span>{{ dataForm.supplierName || '—' }}</span></el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="iqcRequired">
        <el-col :span="12">
          <el-form-item label="入库依据">
            <el-radio-group v-model="sourceType" @change="onSourceTypeChange">
              <el-radio label="inspection">来料检验（须检物料）</el-radio>
              <el-radio :label="arrivalRequired ? 'arrival' : 'order'">{{ arrivalRequired ? '到货通知（免检物料）' : '采购订单（免检物料）' }}</el-radio>
              <el-radio v-if="sourceType === 'order' && arrivalRequired" label="order" :disabled="!formReadonly">采购订单（历史单据）</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item v-if="useInspection" label="来料检验" prop="inspectionId">
            <el-select v-model="dataForm.inspectionId" filterable :clearable="false" placeholder="选择已审检验单" style="width:100%" @change="onInspectionChange">
              <el-option
                v-for="item in inspectionOptions"
                :key="item.inspectionId"
                :label="item.inspectionCode + ' / ' + item.purchaseOrderCode"
                :value="item.inspectionId"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-else-if="useArrival" label="到货通知" prop="arrivalNoticeId">
            <el-select v-model="dataForm.arrivalNoticeId" filterable :clearable="false" placeholder="选择已审到货通知" style="width:100%" @change="onNoticeChange">
              <el-option
                v-for="item in noticeOptions"
                :key="item.noticeId"
                :label="item.noticeCode + ' / ' + item.purchaseOrderCode"
                :value="item.noticeId"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-else label="采购订单" prop="purchaseOrderId">
            <el-select v-model="dataForm.purchaseOrderId" filterable :clearable="false" placeholder="选择已确认订单" style="width:100%" @change="onOrderChange">
              <el-option
                v-for="item in orderOptions"
                :key="item.purchaseOrderId"
                :label="item.purchaseOrderCode + ' / ' + item.supplierName"
                :value="item.purchaseOrderId"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="采购单号"><span>{{ dataForm.purchaseOrderCode || '—' }}</span></el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="备注"><el-input v-model="dataForm.remark" /></el-form-item>
        </el-col>
      </el-row>
      <el-table :key="sourceType" border :data="dataForm.lines" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
        <el-table-column type="index" label="序号" width="55" header-align="center" align="center" />
        <el-table-column prop="materialCode" label="产品编码" min-width="120" header-align="center" align="left" />
        <el-table-column prop="materialName" label="产品名称" min-width="130" header-align="center" align="left" />
        <el-table-column prop="specs" label="规格" min-width="100" header-align="center" align="left" />
        <el-table-column prop="orderedQuantity" label="订购数量" width="90" header-align="center" align="left">
          <template slot-scope="scope">{{ formatQty(scope.row.orderedQuantity) }}</template>
        </el-table-column>
        <el-table-column v-if="useInspection" prop="inspectionQuantity" label="检验数量" width="90" header-align="center" align="left">
          <template slot-scope="scope">{{ formatQty(scope.row.inspectionQuantity) }}</template>
        </el-table-column>
        <el-table-column prop="receivedQuantity" label="已入库数量" width="100" header-align="center" align="left">
          <template slot-scope="scope">{{ formatQty(scope.row.receivedQuantity) }}</template>
        </el-table-column>
        <el-table-column prop="remainQuantity" label="可入库" width="90" header-align="center" align="left">
          <template slot-scope="scope">{{ formatQty(scope.row.remainQuantity) }}</template>
        </el-table-column>
        <el-table-column prop="quantity" label="入库数量" width="170" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.quantity" :min="0" :max="formReadonly ? Math.max(Number(scope.row.quantity || 0), Number(scope.row.remainQuantity || 0)) : Number(scope.row.remainQuantity || 0)" :precision="2" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column label="库位" min-width="280" header-align="center" align="left">
          <template slot-scope="scope">
            <warehouse-location-select v-model="scope.row.wareHouseId" :disabled="formReadonly" />
          </template>
        </el-table-column>
        <el-table-column v-if="!formReadonly" label="操作" width="70" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="dataForm.lines.splice(scope.$index, 1)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formReadonly" type="primary" :disabled="submitLoading" @click="submitHandle">确定</el-button>
    </span>
    <workflow-trail-dialog :visible.sync="trailVisible" :workflow-instance="dataForm.workflowInstance" :tasks="trailTasks" />
  </el-dialog>
</template>

<script>
import WorkflowTrailDialog from '../../components/WorkflowTrailDialog.vue'
import WarehouseLocationSelect from '../../components/WarehouseLocationSelect.vue'
import request from '../../api/request'
import { docAction, docGet, docInfo, docSave } from '../../api/erp/doc'
import { fetchPerms } from '../../api/auth'
import { canShowDirectApproveButton, isWorkflowEditable, normalizeWorkflowDocUi, shouldShowWorkflowTrail } from '../../utils/workflow'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}

function blankForm(id) {
  return {
    stockInId: id || '',
    stockInCode: '',
    stockInDate: today(),
    purchaseOrderId: '',
    purchaseOrderCode: '',
    arrivalNoticeId: '',
    inspectionId: '',
    supplierId: '',
    supplierName: '',
    approveStatus: '0',
    workflowStatus: 'draft',
    workflowInstance: null,
    myPendingTask: null,
    workflowDocUi: null,
    remark: '',
    lines: []
  }
}

export default {
  name: 'PurchaseStockInAddOrUpdate',
  components: { WorkflowTrailDialog, WarehouseLocationSelect },
  data() {
    return {
      visible: false,
      readonly: false,
      submitLoading: false,
      actionBusy: false,
      codeReadonly: false,
      workflowDocUiReady: false,
      trailVisible: false,
      iqcRequired: false,
      arrivalRequired: false,
      sourceType: 'inspection',
      inspectionOptions: [],
      noticeOptions: [],
      orderOptions: [],
      permCodes: [],
      dataForm: blankForm(),
      dataRule: {
        stockInCode: [{ required: true, message: '入库单号不能为空', trigger: 'blur' }],
        stockInDate: [{ required: true, message: '入库日期不能为空', trigger: 'change' }],
        inspectionId: [{ required: true, message: '请选择来料检验', trigger: 'change' }],
        arrivalNoticeId: [{ required: true, message: '请选择到货通知', trigger: 'change' }],
        purchaseOrderId: [{ required: true, message: '请选择采购订单', trigger: 'change' }]
      }
    }
  },
  computed: {
    useInspection() {
      return this.iqcRequired && this.sourceType === 'inspection'
    },
    useArrival() {
      return !this.useInspection && this.sourceType === 'arrival'
    },
    formReadonly() {
      return this.readonly || this.dataForm.approveStatus === '2' || !this.canEditDoc
    },
    formRules() {
      const rules = { ...this.dataRule }
      if (this.codeReadonly) delete rules.stockInCode
      if (this.useInspection) {
        delete rules.arrivalNoticeId
        delete rules.purchaseOrderId
      } else if (this.useArrival) {
        delete rules.inspectionId
        delete rules.purchaseOrderId
      } else {
        delete rules.inspectionId
        delete rules.arrivalNoticeId
      }
      return this.formReadonly ? {} : rules
    },
    dialogTitle() {
      if (this.readonly) return '查看采购入库'
      return this.dataForm.stockInId ? '修改采购入库' : '新增采购入库'
    },
    showViewToolbar() {
      return this.readonly && !!this.dataForm.stockInId
    },
    workflowUi() {
      return normalizeWorkflowDocUi(this.dataForm.workflowDocUi)
    },
    canEditDoc() {
      return isWorkflowEditable(this.dataForm.workflowStatus, this.dataForm.approveStatus)
    },
    allowSaveDirectApprove() {
      const ui = this.workflowUi
      return !!(ui && ui.workflowEnabled && !ui.definitionMatched && ui.directApproveAllowed)
    },
    showApprove() {
      if (!this.showViewToolbar || !this.workflowDocUiReady) return false
      if (String(this.dataForm.approveStatus) === '2') return false
      if (!canShowDirectApproveButton(this.dataForm.workflowDocUi)) return false
      if (this.isAuth('purchase:purchaseStockIn:approve')) return true
      return this.allowSaveDirectApprove && (this.isAuth('purchase:purchaseStockIn:save') || this.isAuth('purchase:purchaseStockIn:update'))
    },
    showUnapprove() {
      return this.showViewToolbar && this.isAuth('purchase:purchaseStockIn:unapprove') && String(this.dataForm.approveStatus) === '2'
    },
    showSubmit() {
      const ui = this.workflowUi
      if (!this.showViewToolbar || !this.workflowDocUiReady || !ui || !ui.submitAllowed) return false
      const uid = (this.$store.state.user || {}).id
      if (this.dataForm.createBy && uid && String(this.dataForm.createBy) !== String(uid)) return false
      return this.isAuth('purchase:purchaseStockIn:submit') || this.isAuth('purchase:purchaseStockIn:save') || this.isAuth('purchase:purchaseStockIn:update')
    },
    showWfApprove() {
      const task = this.dataForm.myPendingTask
      return this.showViewToolbar && this.isAuth('workflow:task:approve') && task && task.taskId
    },
    showWfReject() {
      return this.showWfApprove && this.isAuth('workflow:task:reject')
    },
    showTrail() {
      return shouldShowWorkflowTrail({
        inViewMode: this.showViewToolbar,
        workflowInstance: this.dataForm.workflowInstance,
        workflowDocUi: this.workflowUi,
        workflowDocUiReady: this.workflowDocUiReady
      })
    },
    trailTasks() {
      const inst = this.dataForm.workflowInstance
      return (inst && inst.tasks) || []
    },
    workflowActionHint() {
      const ui = this.workflowUi
      if (!ui || !ui.workflowEnabled || String(this.dataForm.approveStatus) === '2') return ''
      if (ui.inApproval) {
        const uid = (this.$store.state.user || {}).id
        const inst = this.dataForm.workflowInstance
        if (!(this.dataForm.myPendingTask && this.dataForm.myPendingTask.taskId) && inst && uid && String(inst.submitBy) === String(uid)) {
          return '当前步骤需由其他审批人处理（不允许提交人自审），请等待待办人审批。'
        }
        return ''
      }
      if (!ui.definitionMatched && ui.submitAllowed) return '已启用多级审批，尚未配置审批流程。请点击「提交审批」查看配置指引。'
      if (!ui.definitionMatched && ui.directApproveAllowed) return '已启用多级审批，尚未配置匹配的审批流程，可直接审核或联系管理员配置流程。'
      if (!ui.definitionMatched && !ui.directApproveAllowed && !ui.submitAllowed) return '已启用多级审批，请先在「审批流程定义」中配置采购入库流程后再提交。'
      return ''
    }
  },
  created() {
    fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(id, readonly) {
      this.readonly = !!readonly
      this.visible = true
      this.submitLoading = false
      this.actionBusy = false
      this.codeReadonly = !!id
      this.workflowDocUiReady = false
      this.sourceType = 'inspection'
      this.dataForm = blankForm(id)
      this.$nextTick(() => {
        if (this.$refs.dataForm) this.$refs.dataForm.clearValidate()
      })
      if (!id) this.resolveCode()
      this.loadSwitches().then(() => {
        if (id) {
          docInfo('/purchase/purchaseStockIn', id).then(res => {
            const body = res.data || {}
            this.dataForm = {
              ...blankForm(id),
              ...body,
              stockInDate: (body.stockInDate || '').slice(0, 10),
              lines: (body.lines || []).map(line => ({
                ...line,
                quantity: Number(line.quantity),
                remainQuantity: line.remainQuantity != null ? Number(line.remainQuantity) : Number(line.quantity),
                wareHouseId: line.wareHouseId || ''
              }))
            }
            this.sourceType = body.inspectionId ? 'inspection' : body.arrivalNoticeId ? 'arrival' : 'order'
            this.workflowDocUiReady = !!normalizeWorkflowDocUi(this.dataForm.workflowDocUi)
            this.loadSourceOptions(body.inspectionId, body.arrivalNoticeId, body.purchaseOrderId)
          }).catch(() => {})
        } else {
          this.loadSourceOptions()
        }
      })
    },
    loadSwitches() {
      return request.get('/purchase/purchaseStockIn/switches').then(res => {
        const data = res.data || {}
        this.iqcRequired = !!data.iqcRequired
        this.arrivalRequired = !!data.arrivalRequired
        this.sourceType = this.iqcRequired ? 'inspection' : this.arrivalRequired ? 'arrival' : 'order'
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {
        this.iqcRequired = false
        this.arrivalRequired = false
      })
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'purchaseStockIn' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.dataForm.stockInCode = data.previewCode
        this.$nextTick(() => {
          if (this.$refs.dataForm) this.$refs.dataForm.clearValidate('stockInCode')
        })
      }).catch(() => {})
    },
    loadSourceOptions(includeInspectionId, includeNoticeId, includePurchaseOrderId) {
      const exclude = this.dataForm.stockInId || ''
      if (this.useInspection) {
        docGet('/purchase/purchaseStockIn/inspectionsForStockIn', { excludeStockInId: exclude, includeInspectionId: includeInspectionId || '' })
          .then(res => { this.inspectionOptions = res.data || [] }).catch(() => {})
      } else if (this.useArrival) {
        docGet('/purchase/purchaseStockIn/noticesForStockIn', { excludeStockInId: exclude, includeNoticeId: includeNoticeId || '' })
          .then(res => { this.noticeOptions = res.data || [] }).catch(() => {})
      } else {
        docGet('/purchase/purchaseStockIn/ordersForStockIn', { excludeStockInId: exclude, includePurchaseOrderId: includePurchaseOrderId || '' })
          .then(res => { this.orderOptions = res.data || [] }).catch(() => {})
      }
    },
    onSourceTypeChange() {
      this.dataForm.inspectionId = ''
      this.dataForm.arrivalNoticeId = ''
      this.dataForm.purchaseOrderId = ''
      this.dataForm.purchaseOrderCode = ''
      this.dataForm.supplierId = ''
      this.dataForm.supplierName = ''
      this.dataForm.lines = []
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      this.loadSourceOptions()
    },
    onInspectionChange(inspectionId) {
      this.dataForm.lines = []
      const hit = this.inspectionOptions.find(item => item.inspectionId === inspectionId)
      if (!inspectionId || !hit) {
        this.dataForm.purchaseOrderId = ''
        this.dataForm.purchaseOrderCode = ''
        this.dataForm.arrivalNoticeId = ''
        this.dataForm.supplierId = ''
        this.dataForm.supplierName = ''
        return
      }
      this.dataForm.purchaseOrderId = hit.purchaseOrderId
      this.dataForm.purchaseOrderCode = hit.purchaseOrderCode
      this.dataForm.arrivalNoticeId = hit.arrivalNoticeId || ''
      this.dataForm.supplierId = hit.supplierId
      this.dataForm.supplierName = hit.supplierName
      if (!this.formReadonly) this.applyLines()
    },
    onNoticeChange(noticeId) {
      this.dataForm.lines = []
      const hit = this.noticeOptions.find(item => item.noticeId === noticeId)
      if (!noticeId || !hit) {
        this.dataForm.purchaseOrderId = ''
        this.dataForm.purchaseOrderCode = ''
        this.dataForm.supplierId = ''
        this.dataForm.supplierName = ''
        return
      }
      this.dataForm.purchaseOrderId = hit.purchaseOrderId
      this.dataForm.purchaseOrderCode = hit.purchaseOrderCode
      this.dataForm.supplierId = hit.supplierId
      this.dataForm.supplierName = hit.supplierName
      if (!this.formReadonly) this.applyLines()
    },
    onOrderChange(purchaseOrderId) {
      this.dataForm.lines = []
      const hit = this.orderOptions.find(item => item.purchaseOrderId === purchaseOrderId)
      if (!purchaseOrderId || !hit) {
        this.dataForm.purchaseOrderCode = ''
        this.dataForm.supplierId = ''
        this.dataForm.supplierName = ''
        return
      }
      this.dataForm.purchaseOrderCode = hit.purchaseOrderCode
      this.dataForm.supplierId = hit.supplierId
      this.dataForm.supplierName = hit.supplierName
      if (!this.formReadonly) this.applyLines()
    },
    applyLines() {
      const params = { excludeStockInId: this.dataForm.stockInId || '' }
      if (this.useInspection) {
        if (!this.dataForm.inspectionId) return
        params.inspectionId = this.dataForm.inspectionId
      } else if (this.useArrival) {
        if (!this.dataForm.arrivalNoticeId) return
        params.arrivalNoticeId = this.dataForm.arrivalNoticeId
      } else {
        if (!this.dataForm.purchaseOrderId) return
        params.purchaseOrderId = this.dataForm.purchaseOrderId
      }
      docGet('/purchase/purchaseStockIn/linesForStockIn', params).then(res => {
        const lines = res.data || []
        if (!lines.length) {
          this.$message.warning('没有可入库明细')
          return
        }
        this.dataForm.lines = lines.map(line => ({
          ...line,
          remainQuantity: Number(line.remainQuantity || 0),
          quantity: Number(line.quantity != null ? line.quantity : line.remainQuantity || 0),
          wareHouseId: line.wareHouseId || ''
        }))
      }).catch(() => {})
    },
    formatQty(val) {
      if (val == null || val === '') return '-'
      const n = Number(val)
      if (Number.isNaN(n)) return '-'
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    validateLines() {
      if (!this.dataForm.lines.length) return '请至少维护一条入库明细'
      if (this.dataForm.lines.find(line => !(Number(line.quantity) > 0))) return '入库数量必须大于0'
      if (this.dataForm.lines.find(line => !line.wareHouseId)) return '请为每条明细选择入库库位'
      return ''
    },
    submitHandle() {
      const lineErr = this.validateLines()
      if (lineErr) {
        this.$message.error(lineErr)
        return
      }
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const payload = {
          ...this.dataForm,
          inspectionId: this.useInspection ? this.dataForm.inspectionId : null,
          arrivalNoticeId: this.useArrival || this.useInspection ? this.dataForm.arrivalNoticeId : null,
          lines: this.dataForm.lines.map(line => ({
            purchaseOrderLineId: line.purchaseOrderLineId,
            arrivalNoticeLineId: line.arrivalNoticeLineId || null,
            inspectionLineId: line.inspectionLineId || null,
            materialId: line.materialId,
            quantity: line.quantity,
            wareHouseId: line.wareHouseId || '',
            remark: line.remark || ''
          }))
        }
        docSave('/purchase/purchaseStockIn', payload, 'stockInId').then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.submitLoading = false })
      })
    },
    reloadDoc() {
      if (!this.dataForm.stockInId) return
      this.init(this.dataForm.stockInId, true)
    },
    approveHandle() {
      this.$confirm('审核后将增加库存并更新订单已入库数量，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/purchase/purchaseStockIn', 'approve', { stockInId: this.dataForm.stockInId }).then(() => {
          this.$message.success('审核成功')
          this.$emit('refreshDataList')
          this.reloadDoc()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    unapproveHandle() {
      this.$confirm('弃审将恢复库存与订单已入库数量，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/purchase/purchaseStockIn', 'unapprove', { stockInId: this.dataForm.stockInId }).then(() => {
          this.$message.success('弃审成功')
          this.$emit('refreshDataList')
          this.reloadDoc()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    deleteHandle() {
      this.$confirm('确定删除该入库单?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/purchase/purchaseStockIn', 'delete', { stockInId: this.dataForm.stockInId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    submit() {
      const ui = this.workflowUi
      if (ui && ui.workflowEnabled && !ui.definitionMatched) {
        this.$alert('尚未配置采购入库审批流程，请先在「审批流程定义」中新增并启用流程（至少一个审批步骤）后再提交。', '未配置审批流程', { type: 'warning', confirmButtonText: '我知道了' })
        return
      }
      this.$confirm('提交后将进入审批流程，期间不可修改，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        request.post('/workflow/submit', { bizType: 'purchaseStockIn', bizId: this.dataForm.stockInId }).then(() => {
          this.$message.success('提交成功')
          this.reloadDoc()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    wfApprove() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('审批意见（可选）', '审批通过', { inputType: 'textarea', confirmButtonText: '通过' }).then(({ value }) => {
        this.actionBusy = true
        request.post('/workflow/task/approve', { taskId: task.taskId, comment: value || '' }).then(() => {
          this.$message.success('审批通过')
          this.$emit('refreshDataList')
          this.reloadDoc()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    wfReject() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('请输入驳回原因', '审批驳回', {
        inputType: 'textarea',
        confirmButtonText: '驳回',
        inputValidator: v => !!(v && String(v).trim()) || '驳回原因不能为空'
      }).then(({ value }) => {
        this.actionBusy = true
        request.post('/workflow/task/reject', { taskId: task.taskId, comment: String(value).trim() }).then(() => {
          this.$message.success('已驳回')
          this.$emit('refreshDataList')
          this.reloadDoc()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; line-height: 32px; }
.doc-dialog-actions { display: flex; flex-direction: column; align-items: flex-end; }
.doc-dialog-actions >>> .el-button-group { display: flex; flex-wrap: wrap; }
.wf-hint { margin-top: 6px; color: #e6a23c; font-size: 12px; line-height: 1.4; }
</style>
